module.exports = __webpack_public_path__ + "img/bot_intent_zhishiku.ff595c3e.svg";